import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_posts_toolbar_modal = _resolveComponent("posts-toolbar-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_q_btn, _mergeProps({
      icon: "fa fa-filter",
      label: "Filter Posts"
    }, _ctx.$attrs, { onClick: _ctx.openModal }), null, 16, ["onClick"]),
    _createVNode(_component_posts_toolbar_modal, {
      filters: _ctx.filters,
      "onUpdate:filters": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:filters', $event))),
      ref: "modal"
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["filters"])
  ]))
}